(() => {
  if (customElements.get('btm-instagram-cart')) return;
  let state;
  let revision = 0;
  let pending = Promise.resolve();
  let timer;
  const components = () => Array.from(document.querySelectorAll('btm-instagram-cart'));
  const normalize = value => value.trim().replace(/^https?:\/\/(?:www\.)?instagram\.com\//i, '').split(/[?#]/)[0].replace(/^@/, '').replace(/\/$/, '');
  function render() {
    if (!state) return;
    components().forEach(element => {
      const handle = element.querySelector('[data-instagram-handle]');
      if (handle !== document.activeElement) handle.value = state.handle;
      element.querySelector('[data-instagram-feature]').checked = state.feature;
      element.querySelector('[data-instagram-preference]').value = state.handle ? (state.feature ? 'Yes' : 'No') : '';
    });
  }
  function status(key) {
    components().forEach(element => { element.querySelector('[role=status]').textContent = key ? element.dataset[key] : ''; });
  }
  function save() {
    clearTimeout(timer);
    if (!state) return pending;
    const version = revision;
    const attributes = {
      'Instagram handle': normalize(state.handle),
      'Instagram story feature opt-in': state.handle.trim() ? (state.feature ? 'Yes' : 'No') : ''
    };
    pending = pending.catch(() => {}).then(async () => {
      const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes })
      });
      if (!response.ok) throw new Error('Instagram cart details could not be saved');
      const cart = await response.json();
      if ((cart.attributes?.['Instagram handle'] || '') !== attributes['Instagram handle']) throw new Error('Instagram cart details were not saved');
      if (version === revision) status('saved');
    });
    pending.catch(() => { if (version === revision) status('error'); });
    return pending;
  }
  class InstagramCart extends HTMLElement {
    connectedCallback() {
      if (!state) state = {
        handle: this.querySelector('[data-instagram-handle]').value,
        feature: this.querySelector('[data-instagram-feature]').checked
      };
      render();
      if (this.bound) return;
      this.bound = true;
      this.addEventListener('input', event => {
        if (!event.target.matches('[data-instagram-handle]')) return;
        state.handle = event.target.value;
        revision += 1;
        status('');
        render();
        clearTimeout(timer);
        timer = setTimeout(() => { save().catch(() => {}); }, 400);
      });
      this.addEventListener('change', event => {
        if (event.target.matches('[data-instagram-handle]')) {
          state.handle = normalize(event.target.value);
          event.target.value = state.handle;
        } else if (event.target.matches('[data-instagram-feature]')) {
          state.feature = event.target.checked;
        } else return;
        revision += 1;
        render();
        save().catch(() => {});
      });
    }
  }
  customElements.define('btm-instagram-cart', InstagramCart);
  window.btmInstagramCart = { flush: save };
})();
